module.exports = __webpack_public_path__ + "img/airtke_set.ba8d5981.png";